import { render } from "./ChatBotSendMessagePropsCmp.vue?vue&type=template&id=17bf8e4a"
import script from "./ChatBotSendMessagePropsCmp.vue?vue&type=script&lang=js"
export * from "./ChatBotSendMessagePropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__